import React, { useState, useEffect, useRef } from 'react';
import './DetailPageHeroVideo.css';

const DetailPageHeroVideo = ({ src, poster, lazy = true, autoPlay = true, muted = true, loop = true, ...props }) => {
  const [isVisible, setIsVisible] = useState(!lazy);
  const [hasLoaded, setHasLoaded] = useState(false);
  const containerRef = useRef();
  const videoRef = useRef();

  useEffect(() => {
    if (!lazy) {
      setIsVisible(true);
      return;
    }

    const node = containerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { 
        rootMargin: '100px 0px',
        threshold: 0.1 
      }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (observer && node) {
        observer.unobserve(node);
      }
    };
  }, [lazy]);

  // Handle video load event
  const handleVideoLoad = () => {
    setHasLoaded(true);
    if (autoPlay && videoRef.current) {
      // Try to play the video with user interaction handling
      const playAttempt = videoRef.current.play();
      if (playAttempt) {
        playAttempt.catch(error => {
          console.warn('Auto-play failed:', error);
          // Add a play button or alternative UI here if needed
        });
      }
    }
  };

  return (
    <div 
      className="detail-page-hero-video-container"
      ref={containerRef}
      style={{ 
        position: 'relative',
        marginTop: '40px'
      }}
    >
      {isVisible && (
        <video 
          ref={videoRef}
          src={src}
          poster={poster}
          {...props}
          onLoadedData={handleVideoLoad}
          style={{
            opacity: lazy ? (hasLoaded ? 1 : 0) : 1
          }}
          className="detail-page-hero-video"
          muted={muted}
          loop={loop}
          playsInline
          webkit-playsinline="true"
          autoPlay={autoPlay}
          preload="auto"
        />
      )}
    </div>
  );
};

export default DetailPageHeroVideo;